const useLayoutMaxWidth = () => {
  const { config = { ui: { layout: {} } } } = {};
  return config?.ui.layout === "wide"
    ? "min(60rem, 100vw)"
    : "min(48rem, 100vw)";
};

export { useLayoutMaxWidth };
